import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, MenuItem, Modal, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import { useEffect, useState } from "react";
import config from "../../config/config";
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc";
import altProfile from '../../assets/images/altProfile.png';
import dayjs from "dayjs";
import { Label } from "flowbite-react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const DriverPayouts = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows,setRows] = useState([]);
    const [openPayoutModal, setOpenPayoutModal] = useState(false);
    const [dueAmount, setDueAmount] = useState('');
    const [amount, setAmount] = useState('');
    const [openViewModal, setOpenViewModal] = useState(false);
    const [viewRows, setViewRows] = useState([]);
    const [startDateFilter, setStartDateFilter] = useState(dayjs().startOf('month').startOf('day'));
    const [endDateFilter, setEndDateFilter] = useState(dayjs().endOf('month').startOf('day'));
    const navigate = useNavigate();

    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy')
    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const fetchWalletPayoutData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/driver/fetch_wallet_payouts';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD'),
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    const fetchWalletPayoutDriverData = async(driverId) => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/driver/fetch_wallet_payouts';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp,
                driver_id: driverId
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setViewRows(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
        
    useEffect(() => {
        fetchWalletPayoutData();
    }, [startDateFilter, endDateFilter]);

    const handleOpenPayoutModal = (row) => {
        setOpenPayoutModal(true);
        setAmount('');
        setDueAmount(row.due_amount)
    }
    
    const releasePayoutAction = async() => {
        if(amount>dueAmount){
            setMessage('Amount should be less than due amount.');
            showSnackbar(true);
            return;
        }
        // try {
        //     const token = localStorage.getItem('token');
        //     const url = serverUrl + '/driver/release_payout';
        //     const timestamp = new Date().getTime();
        //     const body = {
        //         token: token,
        //         timestamp: timestamp,
        //         amount: amount
        //     };
        //     const response =  await makePostRequestToUrl(url, body);
        //     if(response.flag==200){
        //         setOpenPayoutModal(false);
        //         fetchPromoBannersData();
        //     }
        //     if(response.flag==102){
        //         console.log('Token is expired. Please login again')
        //         localStorage.removeItem('token');
        //         setTokenExpired(true);

        //         setTimeout(() => {
        //             navigate('/signup');
        //         }, 2000);
        //     }
        // }
        // catch (error) {
        //     console.log('error', error);
        // }
    }

    const viewData = (row) => {
        setOpenViewModal(true);
        fetchWalletPayoutDriverData(row.driver_id);
    }

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Driver Payout
            </Typography>

            <Grid2 item sx={{marginTop:'1%', borderRadius:'8px', padding:'8px', width: 'fit-content'}}>
                <Label>Date Range:</Label><br/>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box display="flex" gap={0}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                '& .MuiInputBase-root': {
                                    height: '46px', borderRadius: '8px 0px 0px 8px', marginTop:'4px', backgroundColor:'#fff'
                                }
                            }}
                            value={startDateFilter}
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            onChange={(newValue) => {
                                if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                    setEndDateFilter(null);
                                }
                                setStartDateFilter(newValue);
                            }}
                            maxDate={endDateFilter || undefined}
                        />

                        <DatePicker
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                '& .MuiInputBase-root': {
                                    height: '46px',borderRadius: '0px 8px 8px 0px',marginTop:'4px', backgroundColor:'#fff'
                                }
                            }}
                            value={endDateFilter}
                            onChange={(newValue) => {
                                setEndDateFilter(newValue)
                            }}
                            minDate={startDateFilter || undefined}
                        />
                    </Box>
                </LocalizationProvider>
            </Grid2>

            <TableContainer className="table-container" sx={{maxHeight:'66vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Driver ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Driver</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Due Amount</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Paid Amount</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Total Amount</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Total Trips</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Stripe connected</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            return(
                                <TableRow key={row.driver_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.driver_id}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                            <Grid2>
                                                {row.driver_image!="" && 
                                                    <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={row.driver_name} src={row.driver_image}></Avatar>
                                                }
                                                {row.driver_image=="" && 
                                                    <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='image' src={altProfile}></Avatar>
                                                }
                                            </Grid2>
                                            <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                <Grid2><Typography>{row.driver_name}</Typography></Grid2>
                                                <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{row.phone_number}</Typography></Grid2>
                                            </Grid2>
                                        </Grid2>
                                    </TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '140px' }}>{row.due_amount}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '140px' }}>{row.paid_amount}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '140px' }}>{row.net_amount}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '140px' }}>{row.total_trips}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '140px' }}>{row.is_stripe_connected==1 ? 'Yes' : 'No'}</Typography></TableCell>
                                    
                                    <TableCell align="center">
                                        <Button variant="contained" 
                                        onClick={() => viewData(row)}
                                            sx={{
                                                backgroundColor: "white", color: "black", border: "1px solid black", textTransform: "none", boxShadow:'none',
                                                borderRadius: "8px", width: "auto", minWidth: "140px", marginBottom: "10px",
                                                "&:hover": { backgroundColor: "black", color: "white" }, "&:active": {backgroundColor: "black",color: "white"}
                                            }}
                                        >
                                            View Details
                                        </Button>
                                        <Button variant="contained" 
                                        onClick={() => handleOpenPayoutModal(row)}
                                            sx={{
                                                backgroundColor: "white", color: "#0065ff", border: "1px solid #0065ff", textTransform: "none", boxShadow:'none',
                                                borderRadius: "8px", width: "auto", minWidth: "140px", marginBottom: "10px", marginTop:'1%',
                                                "&:hover": { backgroundColor: "#0065ff", color: "white" }, "&:active": {backgroundColor: "#0065ff",color: "white"}
                                            }}
                                        >
                                            Release Payout
                                        </Button>

                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={openPayoutModal} onClose={handleOpenPayoutModal}
                PaperProps={{ style: { borderRadius: '12px',padding: '10px', width:'30%' }}}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Release Payout <hr/></DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancel-booking-dialog-description">
                        <Grid2 container sx={{marginTop:'2%', alignItems:'center'}}>
                            <Grid2 item size={2}>
                                <Typography>Amount</Typography>
                            </Grid2>
                            <Grid2 item size={1}>:</Grid2>
                            <Grid2 item size={9}>
                                <TextField fullWidth size="small" type='number'
                                    variant="outlined"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    sx={{ width: '100%'}}
                                />
                            </Grid2>
                        </Grid2>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px', marginTop:'2%', justifyContent:'center'}}>
                    <Button 
                        onClick={() => setOpenPayoutModal(false)} 
                        sx={{
                            color: '#6B7280', borderRadius:'8px', textTransform:'none', border: '1px solid #D1D5DB',
                            '&:hover': { backgroundColor: '#F3F4F6', borderColor: '#9CA3AF'}, width:'80px'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={releasePayoutAction} 
                        color="error" variant="contained"
                        sx={{ 
                            backgroundColor: '#0065ff',borderRadius:'8px', textTransform:'none',
                            '&:hover': {backgroundColor: '#0065ff'}, width:'80px'
                        }}
                        autoFocus
                    >
                        Done
                    </Button>
                </DialogActions>
            </Dialog>

            <Modal
                open={openViewModal}
                onClose={()=>setOpenViewModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{position:'absolute',top: '50%',left: '50%',transform: 'translate(-50%, -50%)',width: 1000,
                    bgcolor: 'background.paper',border: '2px solid #000',boxShadow: 20,p: 4}}>
                    <TableContainer className="table-container">
                        <Table stickyHeader className="scrollable-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>ID</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Amount</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Logged On</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {viewRows.length!=0 ? 
                                <>
                                    {viewRows.map((row) => {
                                        return(
                                            <TableRow key={row.id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.id}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.amount}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                    {row.logged_on ? 
                                                        (() => {
                                                        const pickupDate = new Date(row.logged_on);
                                                        // Add the offset minutes to the date
                                                        pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                                        return pickupDate.toLocaleString('en-GB', {
                                                            day: '2-digit', 
                                                            month: '2-digit', 
                                                            year: 'numeric', 
                                                            hour: '2-digit', 
                                                            minute: '2-digit', 
                                                            hour12: timeZoneFormat == '12' ? true : false,
                                                            timeZone: 'UTC'
                                                        }).replace(',', ' |');
                                                        })() 
                                                        : '--'
                                                    }
                                                </Typography></TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </>
                                : 
                                <>
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            <Typography variant="body1">No data found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </>
                                }
                                
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

            </Modal>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
        </div>
    )
}

export default DriverPayouts;